@if (requestType === initialRequestType) {
  <h4 class="stepper-page-title title-2 mb-4">Ordering Provider Details</h4>
}

@if (requestType === subsequentRequestType) {
  <form [formGroup]="physicianTypeForm">
    <p-panel class="mb-4" [toggleable]="false" header="Select the type of provider">
          <p-radio-button
            name="physicianType"
            value="Ordering"
            inputId="physicianType_ordering"
            formControlName="physicianType"
          />
          <label for="physicianType_ordering" class="ml-2 radio-label mr-4">ORDERING PROVIDER</label>
          <p-radio-button
            name="physicianType"
            value="Following"
            inputId="physicianType_following"
            formControlName="physicianType"
          />
          <label for="physicianType_following" class="ml-2 radio-label">FOLLOWING PROVIDER</label>
    </p-panel>
  </form>
}

@if (physicianViewMode === 'Ordering') {
  <div>
    <p-panel header="Search for Provider by the NPI:">
      <app-physician-search
        [tenantId]="tenantId"
        [physicianType]="orderingPhysicianType"
        [isDefaultViewMode]="false"
        [npiNotFound]="npiNotFoundOrdering"
        [isPhysicianNotFoundView]="isOrderingPhysicianNotFound || newOrderingPhysician"
        (npiNotFoundChange)="handleOrderingPhysicianNpiNotFound($event)"
        (physicianResultList)="handleOrderingPhysicianResultList($event)"
        >
      </app-physician-search>
    </p-panel>
    <div class="flex justify-between items-center my-4">
      @if (orderingPhysician && !isOrderingSelectViewMode) {
        <div>
          <span class="font-semibold">{{orderingPhysician.physicianAccountDTO?.accountName}}</span>
        </div>
      }
    </div>
    @if (((orderingPhysicianList && orderingPhysicianList.length) && (orderingPhysician === null)) || npiNotFoundOrdering) {
      <div class="mt-4">
        @if (isOrderingSelectViewMode && !npiNotFoundOrdering && orderingPhysicianList && orderingPhysicianList.length) {
          <p-panel class="panel-padding" [toggleable]="false" header="Select a provider address">
            <app-physician-select
              [searchResultList]="orderingPhysicianList"
              (selectedPhysician)="handleSelectOrderingPhysician($event)"
              >
            </app-physician-select>
          </p-panel>
        }
        @if (isOrderingPhysicianNotFound || npiNotFoundOrdering || newOrderingPhysician) {
          <app-add-physician
            [isExternalUser]="isExternalUser"
            [physician]="newOrderingPhysician"
            [resetForm]="resetForm"
            (physicianChange)="handleAddNewOrderingPhysician($event)"
            >
          </app-add-physician>
        }
      </div>
    }
    @if (orderingPhysician && !isOrderingSelectViewMode) {
      <app-physician-verification
        [physician]="orderingPhysician"
        [isExternalUser]="isExternalUser"
      ></app-physician-verification>
    }
  </div>
} @else {
  <p-panel header="Search for Provider by the NPI:">
    <app-physician-search
      [tenantId]="tenantId"
      [physicianType]="followingPhysicianList"
      [isDefaultViewMode]="false"
      [npiNotFound]="npiNotFoundFollowing"
      [isPhysicianNotFoundView]="isFollowingPhysicianNotFound || newFollowingPhysician"
      [sameAsOrdering]="sameAsOrdering"
      [displayFollowingCheckbox]="this.requestType === this.subsequentRequestType"
      (npiNotFoundChange)="handleFollowingPhysicianNpiNotFound($event)"
      (physicianResultList)="handleFollowingPhysicianResultList($event)"
      (sameAsOrderingChange)="handleSameAsOrderingPhysician($event)"
      >
    </app-physician-search>
  </p-panel>
  <div class="flex justify-between items-center mb-4">
    @if (followingPhysician && !isFollowingSelectViewMode) {
      <div>
        <span class="font-semibold">{{followingPhysician.physicianAccountDTO?.accountName}}</span>
      </div>
    }
  </div>
  <div class="mt-4">
    @if (isFollowingSelectViewMode && !npiNotFoundFollowing && followingPhysicianList?.length) {
      <p-panel class="panel-padding" [toggleable]="false" header="Select a provider address">
        @if (isFollowingSelectViewMode) {
          <app-physician-select
            [searchResultList]="followingPhysicianList"
            (selectedPhysician)="handleSelectFollowingPhysician($event)"
          />
        }
      </p-panel>
    }
    @if (isFollowingPhysicianNotFound || npiNotFoundFollowing || newFollowingPhysician) {
      <app-add-physician
        [isExternalUser]="isExternalUser"
        [physician]="newFollowingPhysician"
        [resetForm]="resetForm"
        (physicianChange)="handleAddNewFollowingPhysician($event)"
      />
    }
  </div>
  @if (followingPhysician && !isFollowingSelectViewMode) {
    <app-physician-verification
      [physician]="followingPhysician"
      [isExternalUser]="isExternalUser"
    />
  }
}



